import React from "react";
import { Avatar } from "antd";

const AVATAR_COLORS = [
  { bg: "#E0E7FF", text: "#3730A3", border: "#C7D2FE" }, // Indigo
  { bg: "#ECFDF5", text: "#065F46", border: "#A7F3D0" }, // Emerald
  { bg: "#F5F3FF", text: "#5B21B6", border: "#DDD6FE" }, // Purple
  { bg: "#FFF7ED", text: "#9A3412", border: "#FED7AA" }, // Orange
  { bg: "#FDF2F8", text: "#9D174D", border: "#FBCFE8" }, // Pink
  { bg: "#F0FDFA", text: "#115E59", border: "#99F6E4" }, // Teal
  { bg: "#FEF3C7", text: "#92400E", border: "#FDE68A" }, // Amber
  { bg: "#EFF6FF", text: "#1E40AF", border: "#BFDBFE" }, // Blue
];

export const getAvatarInitials = (name = "", phone = "") => {
  const cleanName = (name || "").trim();
  const cleanPhone = (phone || "").trim();

  // Check if cleanName is a valid real name (contains letters, not pure phone number)
  if (cleanName && !/^[\d+\s()-]+$/.test(cleanName)) {
    const parts = cleanName.split(/\s+/).filter(Boolean);
    if (parts.length >= 2) {
      return (parts[0][0] + parts[1][0]).toUpperCase();
    }
    if (parts[0].length >= 2) {
      return parts[0].substring(0, 2).toUpperCase();
    }
    return parts[0][0].toUpperCase();
  }

  // If phone number or numeric name
  const targetStr = cleanPhone || cleanName;
  if (targetStr) {
    const digits = targetStr.replace(/\D/g, "");
    if (digits.length >= 2) {
      return digits.slice(-2); // Last 2 digits e.g. "18" for 918...
    }
    return targetStr.substring(0, 2).toUpperCase();
  }

  return "WA";
};

export const getAvatarColor = (seed = "") => {
  let hash = 0;
  const str = String(seed || "");
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  const index = Math.abs(hash) % AVATAR_COLORS.length;
  return AVATAR_COLORS[index];
};

const UserInitialsAvatar = ({
  name,
  phone,
  src,
  size = 32,
  className = "",
  style = {},
}) => {
  const hasRealImage =
    src &&
    typeof src === "string" &&
    src.trim() !== "" &&
    !src.includes("dicebear.com");

  if (hasRealImage) {
    return <Avatar src={src} size={size} className={className} style={style} />;
  }

  const initials = getAvatarInitials(name, phone);
  const colorScheme = getAvatarColor(name || phone || "default");

  return (
    <Avatar
      size={size}
      className={`tw-font-bold tw-flex-shrink-0 tw-uppercase ${className}`}
      style={{
        backgroundColor: colorScheme.bg,
        color: colorScheme.text,
        border: `1px solid ${colorScheme.border}`,
        fontSize: Math.max(10, Math.floor(size * 0.38)),
        lineHeight: 1,
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        userSelect: "none",
        ...style,
      }}
    >
      {initials}
    </Avatar>
  );
};

export default UserInitialsAvatar;
